var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.page.h1 && _vm.page.show_content
    ? _c(
        "section",
        { staticClass: "page-section content-section" },
        [
          _c(
            "page-limiter",
            [
              _c("h1", { staticClass: "page-h1" }, [
                _vm._v(_vm._s(_vm.page.h1))
              ]),
              _c(
                "div",
                {
                  class: [
                    "page-content",
                    _vm.contentcolapsed ? "colapsed" : "",
                    _vm.color
                  ]
                },
                [
                  _c("div", {
                    class: ["page-content-inner"],
                    domProps: { innerHTML: _vm._s(_vm.page.content) }
                  })
                ]
              ),
              _vm.contentcolapsed && _vm.page.content
                ? _c(
                    "btn",
                    {
                      class: ["docs-tabs__title", "btn", "btn--primary"],
                      attrs: { tag: "control" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.uncollapse($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\t\n\t\t\t\t" + _vm._s(_vm.show_title) + "\n\t\t\t"
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ff95042", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ff95042","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PageContent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2ff95042","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PageContent.vue
// module chunks = 0 1 2